module.exports = __webpack_public_path__ + "img/lang_menu.ed012f61.svg";